/**
 * Toast stack (`ui.toast`): connection notices, rematch offers, errors. Top-right, newest at the bottom. On Results
 * the stack moves to the free space above the MVP plate (top-right is the final score), and while a net modal is
 * up it yields to the modal (which says the same thing, bigger).
 */
import { ui } from '@hf/client-core/ui-model/store';
import { isRematchToast } from '@hf/client-core/ui-model/hud';
export { isRematchToast } from '@hf/client-core/ui-model/hud';

const ICON: Record<string, string> = { info: 'i', success: '✓', error: '!' };

export function Toasts() {
  const screen = ui.screen.value;
  const list =
    screen === 'results' ? ui.toasts.value.filter((t) => !isRematchToast(t.text)) : ui.toasts.value;
  const overlay = ui.overlay.value;
  if (list.length === 0 || overlay === 'disconnected' || overlay === 'desynced') return null;
  const where = screen === 'results' ? 'on-results' : '';
  return (
    <div class={`hf-toasts ${where}`} role="status" aria-live="polite">
      {list.map((t) => (
        <div class={`hf-toast ${t.kind}`} key={t.id}>
          <span class="hf-toast__icon t-broadcast" aria-hidden="true">
            {ICON[t.kind]}
          </span>
          <span>{t.text}</span>
        </div>
      ))}
    </div>
  );
}
